import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'translatePlural',
})
export class TranslatePluralPipe implements PipeTransform {
    transform(key: string, number: number): string {
        return `${key}.${number == 0 ? 'singular' : number == 1 ? 'singular' : 'plural'}`;
    }
}
